import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin, Subscription } from 'rxjs';
import { DistanzaIponimiaComponent } from '../distanza_relazioni/distanza-iponimia/distanza-iponimia.component';
import { LayoutMenuComponent } from '../layout-menu/layout-menu.component';
import { DataStorageService } from '../shared/servizi/data-storage.service';
import { SpinnerService } from '../shared/servizi/spinner/spinner.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header.component.css', '../mediaquerie.css']
})
export class HeaderComponent implements OnInit {

  @Input() cy: any;
  @Input() focusNode: string;
  @Output() clicked = new EventEmitter<boolean>();
  @Output() relazioneScelta = new EventEmitter<string>();
  @Output() selectedRadio = new EventEmitter<string>();
  @Output() searchText = new EventEmitter<string>();
  @Output() fetchSenses = new EventEmitter();

  // variabili boolean per nascondere o mostra form distanza ipo o mero
  @Input() showFormIpo: boolean;
  @Input() showFormMero: boolean;
  @Input() showFormSino: boolean;

  // emetto valore form iperonimia
  @Output() valoreFormIperonimia = new EventEmitter<number>();
  // emetto valore form iponimi
  @Output() valoreFormIponimi = new EventEmitter<number>();
  // emetto valore form meronimia 
  @Output() valoreFormMeronimia = new EventEmitter<number>();
  // emetto valore form olonimi
  @Output() valoreFormOlonimia = new EventEmitter<number>();
  // emetto stato tutte relazioni
  @Output() invioStatoTutteRelazioni = new EventEmitter<[]>();
  @Output() invioArrayTutteRelazioni = new EventEmitter<any[]>();
  statoTutteRelazioni: [];
  arrayTutteRelazioni: any[] = [];
  statoNodiRecuperati;

  @Input() layoutCiseScelto: boolean;
  @Input() layoutCoseBilkentScelto: boolean;
  @Input() layoutColaScelto: boolean;
  @Input() layoutEulerScelto: boolean;
  @Input() layoutCoseScelto: boolean;
  layout: any;
  layoutStop = {};

  removedData;
  zoomStep: number = 0.1;
  zoomCurrent: number = 1;

  stato = 'selectRelazione';

  lengthIperonimo: number;

  relazioneIponimiaDistanza: FormGroup;
  distanzaIper;
  distanzaIpo;

  relazioneMeronimiaDistanza;
  distanzaMero;
  distanzaOlo;

  // tutte relazioni
  tutteRelazioni
  visualizzaRelazioni;
  sub1: Subscription;

  isCheck = false;

  @Input() formCercaSenso = new FormGroup({
    cercaUnSenso: new FormControl()
  });

  @Input() valoreCliccato: number;

  @Input() disabFormIpo;

  @Input() formValueIpo: number;
  @Input() formValueIpe: number;
  @Input() formValueMero: number;
  @Input() formValueOlo: number;
  @Input() formValueTutteRel: number;
  // valori ricevuti da ctx menu
  @Input() disabIpo: boolean;
  @Input() disabIpe: boolean;
  @Input() disabMero: boolean;
  @Input() disabOlo: boolean;

  @Input() statoNodiIpo: any[];
  @Input() statoNodiMero: any[];

  @Input() checkboxIpoRicev: boolean;
  @Input() checkboxMeroRicev: boolean;
  @Input() checkboxSinoRicev: boolean;

  // variabili input per stoppare form distanza rel ipo
  @Input() stopIpo: boolean;
  @Input() stopIpe: boolean;


  // variabili input per stoppare form distanza rel mero
  @Input() stopMero: boolean;
  @Input() stopOlo: boolean;

  // variabile per aggiungere/rimuovere classe label  
  @Input() isChecked: boolean;

  /**Definisce se collassare il menu di testa */
  collapsed = true;

  // preselezione mat select
  selected = 'hyponym'

  disabilitaRel: boolean = false;

  // variabili per stoppare input iponimi e iperonimi
  valoreMaxIpo;
  valoreMaxIpe;

  // variabili per stoppare inputmeronimi e olonimi
  valoreMaxMero;
  valoreMaxOlo;

  // variabili per stoppare input tutte relazioni
  valoreMax;

  constructor(
    private ref: ChangeDetectorRef,
    private dataStorageService: DataStorageService,
    public breakpointObserver: BreakpointObserver,
    private spinner: SpinnerService) { }

  @ViewChild(LayoutMenuComponent, { static: true }) istanzaLayoutMenu: LayoutMenuComponent;
  @ViewChild(DistanzaIponimiaComponent, { static: true }) istanzaDistanzaIpo: DistanzaIponimiaComponent;
  
  ngOnChanges(changes: SimpleChanges) {
    this.statoNodiIpo = JSON.parse(sessionStorage.getItem("statoNodiIpo"));
    this.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
    // relazione iponimia rivedere is checked true e false perché da problemi
    if (this.disabIpo === true) {
      this.relazioneIponimiaDistanza.controls['iponimo'].disable();
    } else {
      this.relazioneIponimiaDistanza.controls['iponimo'].enable();
    }
    if (this.disabIpe === true) {
      this.relazioneIponimiaDistanza.controls['iperonimo'].disable();
    } else {
      this.relazioneIponimiaDistanza.controls['iperonimo'].enable();
    }
    // relazione meronimia
    if (this.disabMero === true) {
      this.relazioneMeronimiaDistanza.controls['meronimo'].disable();
    } else {
      this.relazioneMeronimiaDistanza.controls['meronimo'].enable();
    }
    if (this.disabOlo === true) {
      this.relazioneMeronimiaDistanza.controls['olonimo'].disable();
    } else {
      this.relazioneMeronimiaDistanza.controls['olonimo'].enable();
    }
    // setto a 1 i form distanza se  è stato selezionato dal ctx menu
    if (changes.formValueIpe !== undefined) {
      this.relazioneIponimiaDistanza.get('iperonimo').setValue(changes.formValueIpe.currentValue);
    }
    if (changes.formValueIpo !== undefined) {
      this.relazioneIponimiaDistanza.get('iponimo').setValue(changes.formValueIpo.currentValue);
    }
    if (changes.formValueMero !== undefined) {
      this.relazioneMeronimiaDistanza.get('meronimo').setValue(changes.formValueMero.currentValue);
    }
    if (changes.formValueOlo !== undefined) {
      this.relazioneMeronimiaDistanza.get('olonimo').setValue(changes.formValueOlo.currentValue);
    }
    if (changes.formValueTutteRel !== undefined) {
      this.tutteRelazioni.get('relazioni').setValue(changes.formValueTutteRel.currentValue);
    }
  }
  ngOnInit() {
    // form distanza iponimia
    this.relazioneIponimiaDistanza = new FormGroup({
      iperonimo: new FormControl({ value: 0, disabled: false }, [Validators.max(this.valoreMaxIpe), Validators.min(0)]),
      iponimo: new FormControl({ value: 0, disabled: false }, [Validators.max(this.valoreMaxIpo),Validators.min(0)])
    });

    //  form distanza meronimia
    this.relazioneMeronimiaDistanza = new FormGroup({
      meronimo: new FormControl({ value: 0, disabled: true }, [Validators.max(this.valoreMaxMero), Validators.min(0)]),
      olonimo: new FormControl({ value: 0, disabled: true }, [Validators.max(this.valoreMaxOlo), Validators.min(0)])
    });
    this.tutteRelazioni = new FormGroup({
      relazioni: new FormControl({ value: 0, disabled: true }, [Validators.max(this.valoreMax), Validators.min(0)]),
    })
  }

  refreshPagina(): void {
    this.clicked.emit();
    this.removedData = this.cy.elements(':visible').style("display", "none");
    // chiudo pannello infoBox
    const panel = document.getElementById('panel');
    panel.style.display = 'none';
    // svuoto local storage
    // sessionStorage.clear();
    sessionStorage.removeItem('focusNode')
    // svuoto session storage iponimia
    sessionStorage.removeItem('statoNodiIpo')
    sessionStorage.removeItem('statoEdgeIpo')
    sessionStorage.removeItem('statoIponimi')
    sessionStorage.removeItem('statoDistIpo')
    sessionStorage.removeItem('statoIperonimi')
    sessionStorage.removeItem('statoDistIpe')
    sessionStorage.removeItem('relIponimia')
    // svuoto session storage meronimia
    sessionStorage.removeItem('statoNodiMero')
    sessionStorage.removeItem('statoMeronimi')
    sessionStorage.removeItem('statoNodiMero')
    sessionStorage.removeItem('statoEdgeMero')
    sessionStorage.removeItem('statoDistMero')
    sessionStorage.removeItem('statoOlonimi')
    sessionStorage.removeItem('statoDistOlo')
    sessionStorage.removeItem('relMeronimia')
    // svuoto session storage sinonimi
    sessionStorage.removeItem('statoNodiSino')
    sessionStorage.removeItem('statoEdgeSino')
    sessionStorage.removeItem('relSinonimia')
    // svuoto session storage tutte relazioni
    sessionStorage.removeItem('statoTutteRelazioni')
    sessionStorage.removeItem('statoTutteRelazioni')
    sessionStorage.removeItem('tutteRel')
    sessionStorage.removeItem('statoNodiRecuperati')


    this.stato = 'selectRelazione';
    this.disabilitaRel = false;
    this.relazioneScelta.emit('hyponym');
    this.selected = 'hyponym';
    this.fetchSenses.emit();
    // svuoto campo input
    this.formCercaSenso.setValue({ cercaUnSenso: '' });
    this.searchText.emit();
    // resetto valore form distanza iponimia
    this.relazioneIponimiaDistanza.get('iperonimo').setValue(0);
    this.relazioneIponimiaDistanza.get('iponimo').setValue(0);
    this.relazioneIponimiaDistanza.controls['iponimo'].enable();
    this.relazioneIponimiaDistanza.controls['iperonimo'].enable();
    // resetto valore form distanza meronimia
    this.relazioneMeronimiaDistanza.get('meronimo').setValue(0);
    this.relazioneMeronimiaDistanza.get('olonimo').setValue(0);
    this.relazioneMeronimiaDistanza.controls['meronimo'].enable();
    this.relazioneMeronimiaDistanza.controls['olonimo'].enable();
    // resetto form tutte relazioni
    this.tutteRelazioni.get('relazioni').setValue(0);
  }

  centrare(): void {
    var elementiVisibili = this.cy.elements(':visible');
    this.cy.center(elementiVisibili);
  }

  zoomIn(): void {
    if (this.zoomCurrent < this.cy.maxZoom()) {
      this.zoomCurrent += this.zoomStep;
      var elementiVisibili = this.cy.elements(':visible');
      // this.cy.center(elementiVisibili);
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: this.cy.getElementById(sessionStorage.getItem('focusNode')).position('x'), y: this.cy.getElementById(sessionStorage.getItem('focusNode')).position('y') }
      });
    }
  }

  zoomOut(): void {
    if (this.zoomCurrent > this.cy.minZoom()) {
      this.zoomCurrent -= this.zoomStep;
      var elementiVisibili = this.cy.elements(':visible');
      // this.cy.center(elementiVisibili);
      this.cy.zoom({
        level: this.zoomCurrent,
        position: { x: this.cy.getElementById(sessionStorage.getItem('focusNode')).position('x'), y: this.cy.getElementById(sessionStorage.getItem('focusNode')).position('y') }
      });
    }
  }

  onHandleRelazioni(e: string) {
    this.relazioneScelta.emit(e);
  }

  onSelectedRadio(e: string) {
    this.selectedRadio.emit(e);
  }

  distanzaIperonimi() {
    this.distanzaIper = this.relazioneIponimiaDistanza.get('iperonimo').value;
    this.valoreFormIperonimia.emit(this.distanzaIper);
  }


  distanzaIponimi() {
    this.distanzaIpo = this.relazioneIponimiaDistanza.get('iponimo').value;
    this.valoreFormIponimi.emit(this.distanzaIpo);
  }

  distanzaMeronimi() {
    this.distanzaMero = this.relazioneMeronimiaDistanza.get('meronimo').value;
    this.valoreFormMeronimia.emit(this.distanzaMero);
  }

  distanzaOlonimi() {
    this.distanzaOlo = this.relazioneMeronimiaDistanza.get('olonimo').value;
    this.valoreFormOlonimia.emit(this.distanzaOlo);
  }

  relazioni() {
    sessionStorage.getItem('statoTutteRelazioni');
    sessionStorage.getItem('statoNodiRecuperati');
    this.statoNodiRecuperati = JSON.parse(sessionStorage.getItem("statoNodiRecuperati"));
    this.statoTutteRelazioni = JSON.parse(sessionStorage.getItem("statoTutteRelazioni"));
    this.visualizzaRelazioni = this.tutteRelazioni.get('relazioni').value;
    this.spinner.showSpinner();
    // resetto stato se valore form è 0
    if(this.visualizzaRelazioni === 0 ){
      sessionStorage.removeItem('statoTutteRelazioni');
      let nodiVisibili: any = this.cy.elements().filter(':visible');
      let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
      this.cy.remove(nodiVisibili);
      elemSessionStorage.restore();
      this.spinner.hideSpinner();
    } else {
 // chiamate multiple
    // IPONIMIA
    let iponimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.visualizzaRelazioni, "incoming");
    let iponimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'hyponym', this.visualizzaRelazioni, "outgoing");
    // MERONIMIA
    let meronimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.visualizzaRelazioni, "incoming");
    let meronimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.visualizzaRelazioni, "outgoing");
    // SINONIMIA
    let sinonimia1 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'synonym', this.visualizzaRelazioni, "incoming")
    let sinonimia2 = this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'synonym', this.visualizzaRelazioni, "outgoing")
    const arr = [iponimia1, iponimia2, meronimia1, meronimia2, sinonimia1, sinonimia2];
    let multiCall = forkJoin(arr);
    this.sub1 = multiCall.subscribe(subGraph => {
      if(subGraph){
        this.spinner.hideSpinner();
      }
      subGraph.map(relazioni => { 
        if(relazioni.edges.length> 100){
          this.spinner.hideSpinner();
          alert('attenzioni nodi > 100, il caricamento dei sensi viene fermato')
        }
        if(subGraph[0].edges.length > 100 || subGraph[1].edges.length > 100 || subGraph[2].edges.length > 100
          ||subGraph[3].edges.length > 100 ||subGraph[4].edges.length > 100 || subGraph[5].edges.length > 100){
           
            this.tutteRelazioni.get('relazioni').setValue(0);
        } 
        else {   
        let nodi = relazioni.nodes;
        let edges = relazioni.edges;
        let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
        let nodiRecuperati = subGraph[0].nodes.concat(subGraph[1].nodes, subGraph[2].nodes, subGraph[3].nodes, subGraph[4].nodes);
        sessionStorage.setItem("statoNodiRecuperati", JSON.stringify(nodiRecuperati.length));
        let arrSenzaFocus = nodiRecuperati.filter(el => el.data.id !== sessionStorage.getItem('focusNode'));
        let nodiVisibili: any = this.cy.nodes().filter(':visible');
        // controllo per chiudere eventuali nodi visibili con lenght superiore a valore form solo se lo stato è null
        for (var i = 0; i < nodiVisibili.length; i++) {
          if (nodiVisibili.length - 1 > arrSenzaFocus.length) {
            this.cy.remove(nodiVisibili[i]);
            elemSessionStorage.restore();
          }
        }
          for (var i = 0; i < nodi.length; i++) {
            // aggiungo nodi
            this.cy.add([{
              group: "nodes",
              data: {
                id: relazioni.nodes[i].data.id,
                label: relazioni.nodes[i].data.label
              }
            }]);
              this.cy.getElementById(relazioni.nodes[i].data.id).style('display', 'element');
              this.cy.getElementById(relazioni.nodes[i].data.id).addClass('label');
              this.cy.batch(function () {
                elemSessionStorage
                  .removeClass('meronimia')
                  .removeClass('sinonimia')
                  .removeClass('meronimiaDBClick')
                  .removeClass('sinonimiaDBClick')
                  .removeClass('iponimia')
                  .removeClass('iponimiaDBClick')
                  .addClass('tutteRelazioni')
                  ;
              });
              var elementiVisibili = this.cy.elements(':visible');
           
              this.cy.center(elementiVisibili);
              this.arrayTutteRelazioni.length = this.arrayTutteRelazioni.push(relazioni.nodes[i].data.id)
              // stato relazione di iponimia unico (sia iponimi che iperonimi)
              sessionStorage.setItem("statoTutteRelazioni", JSON.stringify(this.arrayTutteRelazioni.length));
              this.invioArrayTutteRelazioni.emit(this.arrayTutteRelazioni);
              this.invioStatoTutteRelazioni.emit(this.statoTutteRelazioni);
          }
          for (var i = 0; i < edges.length; i++) {
            // aggiungo edge
            this.cy.add([{
              group: "edges",
              data: {
                id: relazioni.edges[i].data.id,
                source: relazioni.edges[i].data.source,
                target: relazioni.edges[i].data.target,
                relationType: relazioni.edges[i].data.relationType,
                label: relazioni.edges[i].data.relationType,
                inferred: relazioni.edges[i].data.inferred
              }
            }]);
            this.cy.getElementById(relazioni.edges[i].data.id).style('display', 'element');
            if(edges[i].data.inferred === true){
              this.cy.getElementById(relazioni.edges[i].data.id).addClass('inferred');
            } else {
              if (edges[i].data.relationType === 'hyponym') {
                let iponimia = this.cy.getElementById(edges[i].data.id);
                iponimia.addClass('iponimi');
              } else if (edges[i].data.relationType === 'partMeronym') {
                let meronimia = this.cy.getElementById(edges[i].data.id);
                meronimia.addClass('meronimi');
              } else {
                let sinonimia = this.cy.getElementById(edges[i].data.id);
                sinonimia.addClass('sinonimi');
              }
            }
     
          }
          // iponimi e iperonimi
          let iponimi = subGraph[0].nodes;
          let iperonimi = subGraph[1].nodes;
          for (var i = 0; i < iponimi.length; i++) {
            // shade più chiara
            if (this.cy.getElementById(iponimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(iponimi[i].data.id).addClass('tutteRel_Iponimi');
            }
          }
          for (var i = 0; i < iperonimi.length; i++) {
            // shade più scura
            if (this.cy.getElementById(iperonimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(iperonimi[i].data.id).addClass('tutteRel_Iperonimi');
            }
          }
          // meronimi e olonimi
          let meronimi = subGraph[2].nodes;
          let olonimi = subGraph[3].nodes;
          for (var i = 0; i < meronimi.length; i++) {
            // shade più chiara
            if (this.cy.getElementById(meronimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(meronimi[i].data.id).addClass('tutteRel_Meronimi');
            }
          }
          for (var i = 0; i < olonimi.length; i++) {
            // shade più scura
            if (this.cy.getElementById(olonimi[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(olonimi[i].data.id).addClass('tutteRel_Olonimi');
            }
          }
          // sinonimi
          let sinoEntranti = subGraph[4].nodes;
          let sinoUscenti = subGraph[4].nodes;
          for (var i = 0; i < sinoEntranti.length; i++) {
            if (this.cy.getElementById(sinoEntranti[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(sinoEntranti[i].data.id).addClass('tutteRel_Sinonimi');
            }
          }
          for (var i = 0; i < sinoUscenti.length; i++) {
            if (this.cy.getElementById(sinoUscenti[i].data.id) !== elemSessionStorage) {
              this.cy.getElementById(sinoUscenti[i].data.id).addClass('tutteRel_Sinonimi');
            }
          }
          // iponimia
          let edgeIpo = this.cy.edges('[relationType= "hyponym"]')
          if (this.checkboxIpoRicev === false) {
            for (var i = 0; i < edgeIpo.length; i++) {
              edgeIpo[i].style('display', 'none');
              edgeIpo[i].source().style('display', 'none');
              edgeIpo[i].target().style('display', 'none');
            }
            elemSessionStorage.style('display', 'element')
          } else {
            for (var i = 0; i < edgeIpo.length; i++) {
              edgeIpo[i].style('display', 'element');
              edgeIpo[i].source().style('display', 'element');
              edgeIpo[i].target().style('display', 'element');
            }
          }
          // meronimia
          let edgeMero = this.cy.edges('[relationType= "partMeronym"]')
          if (this.checkboxMeroRicev === false) {
            for (var i = 0; i < edgeMero.length; i++) {
              edgeMero[i].style('display', 'none');
              edgeMero[i].source().style('display', 'none');
              edgeMero[i].target().style('display', 'none');
            }
            elemSessionStorage.style('display', 'element')
          } else {
            for (var i = 0; i < edgeMero.length; i++) {
              edgeMero[i].style('display', 'element');
              edgeMero[i].source().style('display', 'element');
              edgeMero[i].target().style('display', 'element');
            }
          }
          // sinonimia
          let edgeSino = this.cy.edges('[relationType= "synonym"]')
          if (this.checkboxSinoRicev === false) {
            for (var i = 0; i < edgeSino.length; i++) {
              edgeSino[i].style('display', 'none');
              edgeSino[i].source().style('display', 'none');
              edgeSino[i].target().style('display', 'none');
            }
            elemSessionStorage.style('display', 'element')
          } else {
            for (var i = 0; i < edgeSino.length; i++) {
              edgeSino[i].style('display', 'element');
              edgeSino[i].source().style('display', 'element');
              edgeSino[i].target().style('display', 'element');
            }
          }
          this.layoutCiseScelto = true;
        // se è stato scelto il layout cise 
          if (this.layoutCiseScelto === true) {
            // this.layout.stop();
            if (this.visualizzaRelazioni > 0) {
              this.cy.elements().filter(':visible').layout({
                name: 'cise',
                nodeSeparation: 0.1,
                allowNodesInsideCircle: false,
                maxRatioOfNodesInsideCircle: 0.1,
                animate: false,
                refresh: 0.5,
                idealInterClusterEdgeLengthCoefficient: 2,
                fit: false,
              }).run();
              var elementiVisibili = this.cy.elements(':visible');
              this.cy.center(elementiVisibili);
            } else {
              // this.layout.stop();
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cose bilkent 
          if (this.layoutCoseBilkentScelto === true) {
            // this.layout.run();
            var elementiVisibili = this.cy.elements(':visible');
            this.cy.center(elementiVisibili);
            if (this.visualizzaRelazioni > 0) {
              this.cy.elements().filter(':visible').layout({
                name: 'cose-bilkent',
                fit:false
              }).run();
            } else {
              this.layout.stop();
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cola 
          if (this.layoutColaScelto === true) {
            // this.layout.stop();
            var elementiVisibili = this.cy.elements(':visible');
            this.cy.center(elementiVisibili);
            if (this.visualizzaRelazioni > 0) {
              this.cy.elements().filter(':visible').layout({
                name: 'cola',
                fit:false
              }).run();
            } else {
              this.layout.stop();
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout euler
          if (this.layoutEulerScelto === true) {
            // this.layout.stop();
            var elementiVisibili = this.cy.elements(':visible');
            this.cy.center(elementiVisibili);
            if (this.visualizzaRelazioni > 0) {
              this.cy.elements().filter(':visible').layout({
                name: 'euler',
                fit:false
              }).run();
            } else {
              this.layout.stop();
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
          // se è stato scelto il layout cose 
          if (this.layoutCoseScelto === true) {
            // this.layout.stop();
            var elementiVisibili = this.cy.elements(':visible');
            this.cy.center(elementiVisibili);
            if (this.visualizzaRelazioni > 0) {
              this.cy.elements().filter(':visible').layout({
                name: 'cose',
                fit:false
              }).run();
            } else {
              this.layout.stop();
              this.cy.center(elemSessionStorage);
              this.cy.zoom({
                level: 1,
                position: elemSessionStorage.position()
              });
            }
          }
        }
 
      });
      //aggiungo/rimuovo classe label agli edge 
      if (this.isChecked === true) {
        this.cy.edges().filter(':visible').addClass('label');
        this.cy.edges().filter(':visible').style("edge-text-rotation", "autorotate");
      } else {
        this.cy.edges().filter(':visible').removeClass('label');
      }
    });
    }
   
  }
}

